// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"190":"3677751f","726":"4c120d38","775":"23ed2cbe"}[chunkId] + ".chunk.js");